import { takeLatest, all } from 'redux-saga/effects';

import { handleFetchFilesListSaga } from '@sagas/filing/files/handleFetchFilesListSaga';
import { requestFilesList } from '@store/filing/files/files.actions';

export default all([takeLatest(requestFilesList.type, handleFetchFilesListSaga)]);
